import axios from 'axios'

import initPolling from '../shared/polling'

const PARTICIPATION_FORM_SELECTOR = '.js-participation_form'

// milliseconds
const POLLING_SHOULD_NOT_START_AFTER = 600000
const POLLING_TIMEOUT = 120000
const POLLING_INTERVAL = 2000

const pollingInitiatedAt = Date.now()
let stillProcessing = true

const poll = (formParams, campaignId) => {
  return initPolling(
    () => axios.get(`/campaigns/${campaignId}/instagram_profile_validation_status.json`, { params: { participation_form_params: formParams } }).
    then(({ data }) => data), {
      timeout: POLLING_TIMEOUT,
      interval: POLLING_INTERVAL,
      successCondition: response => response.processing === false
    }
  )
}

const toggleInstagramValidityCheckResultPolling = (form, formParams, campaignId) => {
  const submitButtonEl = document.querySelector('.js-new-participation-submit-button')
  const submitButtonContentEl = document.querySelector('.js-new-participation-submit-content')
  const submitButtonLoaderEl = document.querySelector('.js-new-participation-submit-loader')

  toggleSubmitButton(submitButtonEl, submitButtonContentEl, submitButtonLoaderEl)

  if (document.hidden) {
    poll(formParams, campaignId).stop()
  } else if (
    stillProcessing &&
    Date.now() - pollingInitiatedAt < POLLING_SHOULD_NOT_START_AFTER
  ) {
    poll(formParams, campaignId).start().then(
      ({
        processing,
        instagram_public_profile_verified: instagramPublicProfileVerified,
        form_with_error: formWithError
      }) => {
        stillProcessing = processing

        if (stillProcessing) return
        if (formWithError) return handleFormErrors(formWithError)

        toggleSubmitButton(submitButtonEl, submitButtonContentEl, submitButtonLoaderEl)
        createParticipation(
          form,
          Object.assign(formParams, { instagram_public_profile_verified: instagramPublicProfileVerified })
        )
      }
    )
  }
}

const toggleSubmitButton = (submitButtonEl, contentEl, loaderEl) => {
  submitButtonEl.disabled = !submitButtonEl.disabled
  contentEl.hidden = !contentEl.hidden
  loaderEl.hidden = !loaderEl.hidden
}

const createParticipation = (form, params) => {
  $.ajax({
    type: "POST",
    url: form.dataset.createParticipationUrl,
    data: { participation_form: params },
    success: ({ redirect_to: redirectTo }) => window.location.href = redirectTo,
    error: () => window.location.reload()
  })
}

const checkParticipationFormValid = (form) => {
  const successWithErrorStatusCode = 299

  if (!form) return
  form.addEventListener('ajax:success', event => {
    const status = event.detail[2].status
    const response = event.detail[2].response
    if (status !== successWithErrorStatusCode) {
      const parsedResponse = JSON.parse(response)
      if (parsedResponse.processing) {
        stillProcessing = true
        toggleInstagramValidityCheckResultPolling(form, parsedResponse.participation_form_params, parsedResponse.campaign_id)
      } else {
        createParticipation(form, parsedResponse.participation_form_params)
      }
    } else {
      handleFormErrors(response)
    }
  })
}

const handleFormErrors = (formWithErrorsEl) => {
  const participationFormContainer = document.querySelector('.js-partcipation_form_container')
  participationFormContainer.innerHTML = formWithErrorsEl
  const form = participationFormContainer.querySelector(PARTICIPATION_FORM_SELECTOR)
  checkParticipationFormValid(form)
}

export default () => {
  const participationForm = document.querySelector(PARTICIPATION_FORM_SELECTOR)

  if (participationForm) checkParticipationFormValid(participationForm)
}
